import script from "./resource.vue?vue&type=script&setup=true&lang=js"
export * from "./resource.vue?vue&type=script&setup=true&lang=js"

import "./resource.vue?vue&type=style&index=0&id=52819cea&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52819cea"]])

export default __exports__